export default __webpack_public_path__ + "static/media/CleaningKit.edd95833.jpg";